export default __webpack_public_path__ + "src/assets/winter-bg.fc957fd43a5e105e6ed5e1eb395775b1.svg";